export default __webpack_public_path__ + "static/media/icon-success.c139b452.svg";